import Logo from '../../Assets/logo.png'
import * as S from './style'

export const Menu = () => {

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <S.Content>
      <S.Wrapper >
        <S.LogoImg src={Logo} alt="logo Wiseprevent" />

        <S.RightBox>

          <S.BtnMenubox>

            <S.BtnMenu onClick={() => scrollToSection('howItWorks')}>
              Como Funciona
            </S.BtnMenu>

            <S.BtnMenu onClick={() => scrollToSection('benefits')}>
              Benefícios
            </S.BtnMenu>

            <S.BtnMenu onClick={() => scrollToSection('sectors')}>
              Setores
            </S.BtnMenu>

            <S.BtnMenu onClick={() => scrollToSection('aboutUs')}>
              Quem Somos
            </S.BtnMenu>
          </S.BtnMenubox>

          <S.ActionBtn
            className="action-btn"
            onClick={() => window.open("https://wa.me/5541999981633", "_blank")}
          >
            Agende uma demonstração
          </S.ActionBtn>

        </S.RightBox>

      </S.Wrapper>
    </S.Content>
  )
}
